import { render } from "./Slideover.vue?vue&type=template&id=45fbff3c"
import script from "./Slideover.vue?vue&type=script&lang=js"
export * from "./Slideover.vue?vue&type=script&lang=js"
script.render = render

export default script